import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import "./assets/style/style.scss";
import store from "./store/store";
import "./i18n";
import LanguageSelector from "./components/language/LanguageSelector";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      <LanguageSelector />
    </Provider>
  </React.StrictMode>,
);
